export default __webpack_public_path__ + "static/media/480_dummy2016-apotheke01-de.125dc4bd.png";